export default __webpack_public_path__ + "static/media/011_background.2285bbe5.gif";